import React from 'react';
import { Button, Dropdown, Menu, message } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class DiagramRefsEditor extends PropertyEditor {

    state = {
        values: []
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e, index) {
        let values = this.state.values;
        values[index] = e.target.value;
        this.props.source.value = [...values];
        this.setState({ values: values });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ values: this.props.source.value });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ values: this.props.source.value });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ values: nextProps.source.value });
    }

    add() {
        let values = this.state.values;
        values.push(new this.props.source.modelTemplate());
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    deleteItem(index) {
        let values = this.state.values;
        values.splice(index, 1);
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    upItem(index) {
        let values = this.state.values;
        let item = values[index];
        values.splice(index, 1);
        values.splice(index - 1, 0, item);

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    downItem(index) {
        let values = this.state.values;
        let item = values[index];
        values.splice(index, 1);
        values.splice(index + 1, 0, item);

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    append(e) {
        this.props.propertyGrid.append(this.props.source, e);
    }

    onDragEnter(e) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onDragOver(e) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onDrop(e, m) {
        e.preventDefault();

        let id = e.dataTransfer.getData("diagram-ref-id");
        if (!id)
            return;

        const designer = this.props.propertyGrid.props.source._sys.designer;
        const ref = designer.findById(id);
        if (!ref)
            return;

        m._sys.ref = ref;
        m.enabled = true;
        m.id = ref.id;

        this.props.propertyGrid.props.source.listenRefsPropertyChanged();
    }

    render() {
        let values = this.state.values;


        return (
            <div>
                {values.map((v, index) => {

                    const title = v && v.toString();
                    const menu = (
                        <Menu>
                            <Menu.Item key="up" onClick={e => this.upItem(index)}><SvgIconText spacing='md' type='#anticon-Uparrowsmall' text='上移' /></Menu.Item>
                            <Menu.Item key="down" onClick={e => this.downItem(index)}><SvgIconText spacing='md' type='#anticon-Downarrowsmall' text='下移' /></Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="delete" onClick={e => this.deleteItem(index)}><SvgIconText spacing='md' type='#anticon-trash-gray1' text='移除' /></Menu.Item>
                        </Menu>
                    );

                    return (
                        <div key={index} className="layout-h" style={{ marginTop: 3 }}
                            onDragEnter={e => this.onDragEnter(e)}
                            onDragOver={e => this.onDragOver(e)}
                            onDrop={e => this.onDrop(e, v)}
                        >
                            <Button className="hstretch fill" onClick={e => this.append(v)} title={title} style={{ width: 0, padding: "5px 7px 5px 7px", textAlign: "left" }}>
                                <div className={"hstretch text-nowrap " + ((!v || !v.enabled) && v.enabled !== undefined ? "deleted-text" : "")}>{title}</div>
                            </Button>

                            <Dropdown overlay={menu} trigger={['click']}>
                                <Button
                                    className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                                    style={{ padding: '7px 5px' }}>
                                    <EllipsisOutlined type="ellipsis" />
                                </Button>
                            </Dropdown>
                            {/* <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector sp-left" onClick={e => this.deleteItem(index)} >
                            <SvgIconText type="#anticon-trash-gray1" />
                        </Button> */}
                        </div>
                    )
                })}
                <Button onClick={this.add.bind(this)}>添加</Button>
            </div>
        );
    }
}

PropertyGridUtils.register("diagram-refs", (source, propertyGrid) => <DiagramRefsEditor source={source} propertyGrid={propertyGrid} />);
